import React from 'react'
import VestimentaImagenBotones from "../components/lineamientos/VestimentaImagenBotones";

export const VestimentaImagenPage = () => {
    return (
        <div>
            <VestimentaImagenBotones/>
        </div>
    )
}
